import http from 'hub-http/clients/apiClient';
import { registerQuery, useQuery } from 'academy-common-lib/utils/DataFetchingClient';
export const BASE_URI_PROGRESS = '/academy/learning-center/progress/v1';
const GET_LESSON_PROGRESS = registerQuery({
  fieldName: 'lessonProgress',
  args: ['lessonId'],
  fetcher({
    lessonId
  }) {
    return http.get(`${BASE_URI_PROGRESS}/user-progress/lesson/${lessonId}`);
  }
});
export const useLessonProgressById = (lessonId, skip) => {
  const {
    data: lessonProgressById,
    loading: lessonProgressByIdLoading,
    error: lessonProgressByIdError
  } = useQuery(GET_LESSON_PROGRESS, {
    variables: {
      lessonId: Number(lessonId)
    },
    skip: !lessonId || skip,
    fetchPolicy: 'cache-first',
    onError: error => {
      throw new Error(error.message);
    }
  });
  return {
    lessonProgressById,
    lessonProgressByIdLoading,
    lessonProgressByIdError
  };
};